import React from "react";
import { Link } from "react-router-dom";
import { DataNav } from "../data/DataNav";
import WOW from "wowjs";
import { useEffect } from "react";

// DATA
import { DataContactOne } from "../data/DataContact";

function Footer() {
  useEffect(() => {
    const wow = new WOW.WOW({
      live: false, // This disables continuous scanning for new elements
    });
    wow.init();
  }, []);

  return (
    <div>
      <>
        <footer className="footer-area footer-style-one-wrapper bg-color-footer bg_images tmp-section-gap">
          <div className="container">
            <div className="footer-main footer-style-one">
              <div className="row g-5">
                <div className="col-lg-4 col-md-6">
                  <div className="single-footer-wrapper border-right mr--20">
                    <div
                      className="logo wow pulse"
                      data-wow-iteration="infinite"
                      data-wow-duration="2s"
                    >
                      <Link to="/">
                        <img
                          style={{ width: "188px", height: "61px" }}
                          src="assets/images/logo/logo-02.svg"
                          alt="logo"
                        />
                      </Link>
                    </div>
                    <p className="description">{DataContactOne.littleIfo}</p>
                    <div className="day-time">
                      <div className="icon">
                        <i className="fa-solid fa-alarm-clock" />
                      </div>
                      <div className="content">
                        <div className="day">{DataContactOne.workingDays}</div>
                        <div className="time">
                          {DataContactOne.workingHours}
                        </div>
                      </div>
                    </div>
                    <ul className="social-icons solid-social-icons rounded-social-icons">
                      {DataContactOne?.mediaLinks.map((item) => {
                        if (item.name === "facebook") {
                          return (
                            <li key={item.id}>
                              <a
                                href={`https://ci.linkedin.com/company/setelec-sas`}
                                target="_blank"
                              >
                                <i className={`fa-brands fa-${item.name}-f`} />
                              </a>
                            </li>
                          );
                        } else {
                          return (
                            <li key={item.id}>
                              <a href="#">
                                <i className={`fa-brands fa-${item.name}`} />
                              </a>
                            </li>
                          );
                        }
                      })}
                    </ul>
                  </div>
                </div>
                <div className="col-lg-2 col-md-6">
                  <div className="single-footer-wrapper pl-50 pl_md--0 pl_sm--0">
                    <h5 className="ft-title">Lien Rapide</h5>
                    <ul className="ft-link">
                      {DataNav.map((item) => {
                        return (
                          <li key={item.id}>
                            <Link to={item.link}>{item.label}</Link>
                          </li>
                        );
                      })}
                    </ul>
                  </div>
                </div>
                <div className="col-lg-3 col-md-6">
                  {/* <div className="single-footer-wrapper pr--15">
                    <h5 className="ft-title">Recent Post</h5>
                    <div className="single-post">
                      <div className="thumbnail">
                        <img
                          src="assets/images/footer/small-post.jpg"
                          alt="Business_Corporate"
                        />
                      </div>
                      <div className="content">
                        <div className="date">
                          <i className="fa-light fa-calendar-days" />
                          <span>12 Feb, 2022</span>
                        </div>
                        <Link to={"/BlogDetails"}>
                          <h6 className="title">
                            Day tree hide from hath gathered multy
                          </h6>
                        </Link>
                      </div>
                    </div>
                    <div className="single-post">
                      <div className="thumbnail">
                        <img
                          src="assets/images/footer/small-post-2.jpg"
                          alt="Business_Corporate"
                        />
                      </div>
                      <div className="content">
                        <div className="date">
                          <i className="fa-light fa-calendar-days" />
                          <span>12 Feb, 2022</span>
                        </div>
                        <Link to={"/BlogDetails"}>
                          <h6 className="title">
                            Saving Time Achieving Success in Business
                          </h6>
                        </Link>
                      </div>
                    </div>
                  </div> */}
                </div>
                <div className="col-lg-3 col-md-6">
                  <div className="single-footer-wrapper">
                    <h5 className="ft-title">Info Officielle:</h5>
                    <ul className="ft-link">
                      <li className="ft-location">
                        le siège social est situé à {DataContactOne.address}
                      </li>
                      <li>
                        <div className="single-contact">
                          <div className="icon">
                            <i className="fa-solid fa-envelope-open-text" />
                          </div>
                          <div className="content">
                            <span>E-mail:</span>
                            <Link to={`mailto:${DataContactOne.email}`}>
                              {DataContactOne.email}
                            </Link>
                          </div>
                        </div>
                      </li>
                      <li>
                        <div className="single-contact">
                          <div className="icon">
                            <i className="fa-light fa-phone" />
                          </div>
                          <div className="content">
                            <span>Téléphone:</span>
                            <Link to={`tel:${DataContactOne.phone}`}>
                              {DataContactOne.phone}
                            </Link>
                            <br />
                            <Link to={`tel:${DataContactOne.phone2}`}>
                              {DataContactOne.phone2}
                            </Link>
                          </div>
                        </div>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </footer>
        <div className="copyright-area-one">
          <div className="container">
            <div className="row">
              <div className="col-lg-12">
                <div className="main-wrapper">
                  <p>
                    © Copyright 2025. All Rights Reserved by{" "}
                    <Link to="#">SETELEC SAS</Link>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    </div>
  );
}

export default Footer;
